import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";

import "./MyProgressListing.scss";
import { 
	getMyProgressList,
	getMyWorkouts,
	resetField, 
	deleteExerciseFromPlan,
	deleteMyWorkouts } from "../../../store/actions";
import Tooltip from "../../../sharedComponents/tooltip";
import ConfirmDelete from "../../../sharedComponents/confirmDelete";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import EditExercise from "../myWorkout/editExercise";

import AddPlanPanel from "./addPlanPanel";
import AddExercises from "../myWorkout/addExercises";
import AddLogPanel from "./addLogPanel";
import MyProgressTabs from "./myProgressTabs";

const MyProgressListing = ({
	history,
	exercises,
	getMyProgressList,
	exercise,
	resetField,
	getMyWorkouts,
	deleteExerciseFromPlan,
	deleteMyWorkouts,
}) => {
	const [editFormValues, setEditFormValue] = useState({});
	const [deleteItem, setDeleteItem] = useState(null);
	const [editWorkout, setEditWorkout] = useState(false);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		getMyWorkouts();
	}, [getMyWorkouts]);

	const handleEditExercise = (data) => {
		resetField("MyWorkout.toggleEditPanel", true);
		const newData = {
			...data,
			monday: data.monday ? data.monday : 0,
			tuesday: data.tuesday ? data.tuesday : 0,
			wednesday: data.wednesday ? data.wednesday : 0,
			thursday: data.thursday ? data.thursday : 0,
			friday: data.friday ? data.friday : 0,
			saturday: data.saturday ? data.saturday : 0,
			sunday: data.sunday ? data.sunday : 0
		};
		setEditFormValue(newData);
	};

	const handleEditWorkout = () => {
		setEditWorkout(true);
	}

	const handleShowWorkout = () => {
		setEditWorkout(false);
	}

	const handleDeleteExercise = (data) => {
		setDeleteItem(data);
	};

	const confirmEvent = (yes) => {
		const successHandler = () => {
			getMyWorkouts();
		};
		if (yes && deleteItem) {
			deleteExerciseFromPlan(deleteItem, successHandler);
		}
		if (yes && showModal) {
			deleteMyWorkouts(successHandler);
		}
		setDeleteItem(null);
		setShowModal(false);
	};

	const columns = [
		{
			Header: "Exercise",
			accessor: "exercise_data.name",
			sortable: false,
			width: 300,
			Cell: ({ original }) => (
				<Link to={`/fitness/exercises/${original.exercise_data.id}/details`}>
					{original.exercise_data.name ? original.exercise_data.name : " - "}
				</Link>
			)
		},
		{
			Header: "Monday",
			accessor: "monday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.monday ? (<span className="icon icon-check"></span>) : " - "}</span>
		},
		{
			Header: "Tuesday",
			accessor: "tuesday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.tuesday ? (<span className="icon icon-check"></span>) : " - "}</span>
		},
		{
			Header: "Wednesday",
			accessor: "wednesday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.wednesday ? (<span className="icon icon-check"></span>) : " - "}</span>
		},
		{
			Header: "Thursday",
			accessor: "thursday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.thursday ? (<span className="icon icon-check"></span>) : " - "}</span>
		},
		{
			Header: "Friday",
			accessor: "friday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.friday ? (<span className="icon icon-check"></span>) : " - "}</span>
		},
		{
			Header: "Saturday",
			accessor: "saturday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.saturday ? (<span className="icon icon-check"></span>) : " - "}</span>
		},
		{
			Header: "Sunday",
			accessor: "sunday",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.sunday ? (<span className="icon icon-check"></span>) : " - "}</span>
		},
		{
			Header: "Actions",
			accessor: "id",
			sortable: false,
			className: "text-right",
			headerClassName: "text-right",
			Cell: ({ original }) => (
				<div>
					<Tooltip content="Edit" placement="left">
						<button
							className="btn btn-success btn-ghost btn-cell btn-sm mr-2"
							onClick={() => handleEditExercise(original)}>
							<i className="icon icon-edit" />
						</button>
					</Tooltip>
					<Tooltip content="Delete" placement="left">
						<button
							className="btn btn-danger btn-ghost btn-cell btn-sm"
							onClick={() => handleDeleteExercise(original)}>
							<i className="icon icon-trash" />
						</button>
					</Tooltip>
				</div>
			)
		}
	];

	return (
		<section className="page page-my-progress-list">
			<div className="container">
				<div className="d-flex mb-3 align-items-center">
					<h3 className="flex-fill m-0">My Workout</h3>
					{editWorkout ? (
						<div className="pl-3">
							<Tooltip content={"Edit Workout"}>
								<button className="btn btn-ghost btn-primary-dark" type="button" onClick={handleShowWorkout}>
									<i className="icon icon-log-time"></i>Show Workout
								</button>
							</Tooltip>
						</div>
					) : (
						<div className="pl-3">
							<Tooltip content={"Edit Workout"}>
								<button className="btn btn-ghost btn-primary-dark" type="button" onClick={handleEditWorkout}>
									<i className="icon icon-log-time"></i>Edit Workout
								</button>
							</Tooltip>
						</div>
					)}
				</div>
				{editWorkout ? (
					<div className="row">
						<div className="col-12">
							<PaginatedTable
								data={exercises ? exercises : []}
								columns={columns}
								pageSize={exercises ? exercises.length : 0}
							/>
						</div>
						<div className="col-12" style={{textAlign: 'right'}}>
							<button className="btn btn-danger btn-ghost ml-3 align-top" onClick={() => setShowModal(true)}>
								<i className="icon icon-trash" /> Remove all
							</button>
						</div>
					</div>
				) : (
					<div className="row">
						<div className="col-12">
							<div className="block block-primary p-3">
								<MyProgressTabs history={history} />
							</div>
						</div>
					</div>
				)}
			</div>
			<AddPlanPanel history={history} />
			<AddExercises history={history} />
			<AddLogPanel
				history={history}
				initialValues={{
					datedone: exercise ? moment(exercise.logDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
				}}
				progressList={getMyProgressList}
			/>
			{editFormValues && editFormValues.id && <EditExercise initialValues={editFormValues} />}
			<ConfirmDelete
				item={deleteItem ? deleteItem : showModal}
				message={<div>Are you sure you want to delete?</div>}
				onEvent={confirmEvent}
			/>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Exercises, MyWorkout } = state;
	return {
		exercise: get(Exercises, "exerciseToLog", null),
		exercises: get(MyWorkout, "myWorkoutList.results", []),
		toggleEditPanel: get(MyWorkout, "toggleEditPanel"),
	};
};

const mapDispatchToProps = {
	resetField,
	getMyProgressList,
	getMyWorkouts,
	deleteMyWorkouts,
	deleteExerciseFromPlan
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MyProgressListing);
